import React, { useState, useEffect } from "react";
import servicesService from "./services/servicesService";

// Main Banner Images
import image1 from "./image1.jpg"; // Residential
import image2 from "./image2.jpg"; // Commercial
import image3 from "./image3.jpg"; // Renovation

// Residential Base Images
import img1 from "./img1.jpg"; // Crockery Unit
import img2 from "./img2.jpg"; // Living
import img3 from "./img3.jpg"; // Modular Kitchen
import img4 from "./img4.jpg"; // Pooja Unit
import img5 from "./img5.jpg"; // TV Unit
import img6 from "./img6.jpg"; // Wardrobe

// --- Inner Galleries Assets ---
// Crockery Unit
import crok1 from "./crok1.jpg"; import crok2 from "./crok2.jpg"; import crok3 from "./crok3.jpg"; import crok4 from "./crok4.jpg"; import crok5 from "./crok5.jpg";
import crok6 from "./crok6.jpg"; import crok7 from "./crok7.jpg"; import crok8 from "./crok8.jpg"; import crok9 from "./crok9.jpg"; import crok10 from "./crok10.jpg";
import crok11 from "./crok11.jpg"; import crok12 from "./crok12.jpg"; import crok13 from "./crok13.png"; import crok14 from "./crok14.jpg"; import crok16 from "./crok16.jpg"; import crok17 from "./crok17.jpg";

// Living
import liv1 from "./liv1.jpg"; import liv2 from "./liv2.jpg"; import liv3 from "./liv3.jpg"; import liv4 from "./liv4.jpg"; import liv5 from "./liv5.jpg";
import liv6 from "./liv6.jpg"; import liv7 from "./liv7.jpg"; import liv8 from "./liv8.jpg"; import liv9 from "./liv9.jpg"; import liv10 from "./liv10.jpg";
import liv12 from "./liv12.jpg"; import liv13 from "./liv13.jpg"; import liv14 from "./liv14.jpg"; import liv15 from "./liv15.jpg"; 
import liv17 from "./liv17.jpg"; import liv18 from "./liv18.jpg"; import liv19 from "./liv19.jpg"; import liv20 from "./liv20.jpg"; import liv21 from "./liv21.jpg"; import liv22 from "./liv22.jpg"; import liv23 from "./liv23.jpg";

// Modular Kitchen
import mod1 from "./mod1.jpg"; import mod2 from "./mod2.jpg"; import mod3 from "./mod3.jpg"; import mod4 from "./mod4.jpg"; import mod5 from "./mod5.jpg";
import mod6 from "./mod6.jpg"; import mod7 from "./mod7.jpg"; import mod8 from "./mod8.jpg"; import mod9 from "./mod9.jpg"; import mod10 from "./mod10.jpg";
import mod12 from "./mod12.jpg"; import mod14 from "./mod14.jpg"; import mod15 from "./mod15.jpg"; import mod16 from "./mod16.jpg"; import mod17 from "./mod17.jpg";

// Pooja Unit
import poo1 from "./poo1.jpg"; import poo2 from "./poo2.jpg"; import poo3 from "./poo3.jpg"; import poo4 from "./poo4.jpg"; import poo5 from "./poo5.jpg";
import poo6 from "./poo6.jpg"; import poo7 from "./poo7.jpg"; import poo8 from "./poo8.jpg"; import poo9 from "./poo9.jpg"; import poo10 from "./poo10.jpg";
import poo11 from "./poo11.jpg"; import poo12 from "./poo12.jpg";

// TV Unit
import tv1 from "./tv1.jpg"; import tv2 from "./tv2.jpg"; import tv3 from "./tv3.jpg"; import tv4 from "./tv4.jpg"; import tv5 from "./tv5.jpg";
import tv6 from "./tv6.jpg"; import tv7 from "./tv7.jpg"; import tv8 from "./tv8.jpg"; import tv9 from "./tv9.jpg"; import tv10 from "./tv10.jpg";
import tv11 from "./tv11.jpg"; import tv12 from "./tv12.jpg"; import tv14 from "./tv14.jpg"; import tv15 from "./tv15.jpg"; import tv16 from "./tv16.jpg";

// Wardrobe
import ward1 from "./ward1.jpg"; import ward2 from "./ward2.jpg"; import ward3 from "./ward3.jpg"; import ward4 from "./ward4.jpg"; import ward5 from "./ward5.jpg";
import ward6 from "./ward6.jpg"; import ward7 from "./ward7.jpg"; import ward8 from "./ward8.jpg"; import ward9 from "./ward9.jpg"; import ward10 from "./ward10.jpg";
import ward11 from "./ward11.jpg"; import ward12 from "./ward12.jpg"; import ward13 from "./ward13.jpg"; import ward14 from "./ward14.jpg"; import ward15 from "./ward15.jpg"; import ward16 from "./ward16.jpg"; import ward17 from "./ward17.jpg"; import ward18 from "./ward18.jpg";

// Commercial Images
import commer1 from "./commer1.jpg";
import commer2 from "./commer2.jpg";
import commer3 from "./commer3.jpg";
import commer4 from "./commer4.jpg";
import commer5 from "./commer5.jpg";
import commer6 from "./commer6.jpg";

// Renovation Images
import Reno1 from "./Reno1.jpg";
import Reno2 from "./Reno2.jpg";
import Reno3 from "./Reno3.jpg";
import Reno4 from "./Reno4.jpg";
import Reno5 from "./Reno5.jpg";
import Reno6 from "./Reno6.jpg";

const galleryAssetMap = {
  residential: {
    banner: image1,
    items: [
      { title: "Crockery Unit", image: img1, subImages: [crok1, crok2, crok3, crok4, crok5, crok6, crok7, crok8, crok9, crok10, crok11, crok12, crok13, crok14, crok16, crok17] },
      { title: "Living", image: img2, subImages: [liv1, liv2, liv3, liv4, liv5, liv6, liv7, liv8, liv9, liv10, liv12, liv13, liv14, liv15, liv17, liv18, liv19, liv20, liv21, liv22, liv23] },
      { title: "Modular Kitchen", image: img3, subImages: [mod1, mod2, mod3, mod4, mod5, mod6, mod7, mod8, mod9, mod10, mod12, mod14, mod15, mod16, mod17] },
      { title: "Pooja Unit", image: img4, subImages: [poo1, poo2, poo3, poo4, poo5, poo6, poo7, poo8, poo9, poo10, poo11, poo12] },
      { title: "TV Unit", image: img5, subImages: [tv1, tv2, tv3, tv4, tv5, tv6, tv7, tv8, tv9, tv10, tv11, tv12, tv14, tv15, tv16] },
      { title: "Wardrobe", image: img6, subImages: [ward1, ward2, ward3, ward4, ward5, ward6, ward7, ward8, ward9, ward10, ward11, ward12, ward13, ward14, ward15, ward16, ward17, ward18] },
    ]
  },
  commercial: {
    banner: image2,
    items: [
      { title: "Office Workspace", image: commer1 },
      { title: "Reception Lobby", image: commer2 },
      { title: "Conference Room", image: commer3 },
      { title: "Retail Shop", image: commer4 },
      { title: "Cafe / Restaurant", image: commer5 },
      { title: "Executive Cabin", image: commer6 },
    ]
  },
  renovation: {
    banner: image3,
    items: [
      { title: "Home Renovation", image: Reno1 },
      { title: "Kitchen Renovation", image: Reno2 },
      { title: "Bedroom Renovation", image: Reno3 },
      { title: "Living Room Renovation", image: Reno4 },
      { title: "Bathroom Renovation", image: Reno5 },
      { title: "Complete Interior Renovation", image: Reno6 },
    ]
  },
  kitchen: {
    banner: img3,
    items: [
      { title: "Modular Kitchen Designs", image: img3, subImages: [mod1, mod2, mod3, mod4, mod5, mod6, mod7, mod8, mod9, mod10, mod12, mod14, mod15, mod16, mod17] }
    ]
  },
  wardrobe: {
    banner: img6,
    items: [
      { title: "Luxury Wardrobes", image: img6, subImages: [ward1, ward2, ward3, ward4, ward5, ward6, ward7, ward8, ward9, ward10, ward11, ward12, ward13, ward14, ward15, ward16, ward17, ward18] }
    ]
  },
  pooja: {
    banner: img4,
    items: [
      { title: "Sacred Pooja Mandirs", image: img4, subImages: [poo1, poo2, poo3, poo4, poo5, poo6, poo7, poo8, poo9, poo10, poo11, poo12] }
    ]
  },
  tv: {
    banner: img5,
    items: [
      { title: "Entertainment TV Units", image: img5, subImages: [tv1, tv2, tv3, tv4, tv5, tv6, tv7, tv8, tv9, tv10, tv11, tv12, tv14, tv15, tv16] }
    ]
  },
  crockery: {
    banner: img1,
    items: [
      { title: "Crockery & Dining Consoles", image: img1, subImages: [crok1, crok2, crok3, crok4, crok5, crok6, crok7, crok8, crok9, crok10, crok11, crok12, crok13, crok14, crok16, crok17] }
    ]
  }
};

function getServiceAsset(service) {
  const slug = (service.slug || service.name || "").toLowerCase();
  if (slug.includes("commercial") || slug.includes("office")) return galleryAssetMap.commercial;
  if (slug.includes("renovat") || slug.includes("remodel")) return galleryAssetMap.renovation;
  if (slug.includes("kitchen")) return galleryAssetMap.kitchen;
  if (slug.includes("wardrobe") || slug.includes("closet")) return galleryAssetMap.wardrobe;
  if (slug.includes("pooja") || slug.includes("mandir")) return galleryAssetMap.pooja;
  if (slug.includes("tv") || slug.includes("entertainment")) return galleryAssetMap.tv;
  if (slug.includes("crockery") || slug.includes("dining")) return galleryAssetMap.crockery;
  return galleryAssetMap.residential;
}

function Services() {
  const [dbServices, setDbServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedService, setSelectedService] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  // States to hold full screen image slider data
  const [activeGallery, setActiveGallery] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);

  useEffect(() => {
    async function loadActiveServices() {
      try {
        setLoading(true);
        const data = await servicesService.getActive();
        setDbServices(data || []);
      } catch (err) {
        console.error("Error loading services from Supabase:", err);
      } finally {
        setLoading(false);
      }
    }
    loadActiveServices();
  }, []);

  const handleCloseMainPopup = () => {
    setSelectedService(null);
    setSelectedSubCategory(null);
  };

  const getPopupDetails = () => {
    if (!selectedService) return null;
    const asset = getServiceAsset(selectedService);
    return {
      title: `${selectedService.name} Collection`,
      description: selectedService.description,
      items: asset.items,
    };
  };

  const currentPopup = getPopupDetails();

  // Navigation logic for lightbox
  const openFullScreen = (imagesArray, index) => {
    setActiveGallery(imagesArray);
    setCurrentImageIndex(index);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % activeGallery.length);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? activeGallery.length - 1 : prevIndex - 1
    );
  };

  const handleCloseFullScreen = () => {
    setCurrentImageIndex(null);
    setActiveGallery([]);
  };

  // Keyboard navigation support
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentImageIndex !== null) {
        if (e.key === "ArrowRight") handleNextImage();
        if (e.key === "ArrowLeft") handlePrevImage();
        if (e.key === "Escape") handleCloseFullScreen();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentImageIndex, activeGallery]);

  return (
    <>
      <section
        id="services"
        className="relative py-24 overflow-hidden bg-gradient-to-br from-white via-slate-50 to-[#9BB7A3]/10"
      >
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-72 h-72 bg-[#9BB7A3]/10 rounded-full blur-3xl animate-pulse"></div>
          <div
            className="absolute bottom-10 right-10 w-80 h-80 bg-[#9BB7A3]/10 rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "2s" }}
          ></div>
          <div
            className="absolute top-1/2 left-1/2 w-[450px] h-[450px] border border-[#9BB7A3]/10 rounded-full animate-spin"
            style={{
              animationDuration: "45s",
              transform: "translate(-50%, -50%)",
            }}
          ></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="uppercase tracking-[6px] text-[#9BB7A3] font-bold text-sm">
              Our Services
            </span>
            <h2 className="mt-4 text-3xl md:text-5xl font-black text-slate-800">
              What We Create
            </h2>
            <p className="mt-4 text-slate-600 max-w-2xl mx-auto">
              Creating elegant residential spaces, commercial interiors and turnkey renovation solutions.
            </p>
          </div>

          {loading ? (
            <div className="py-20 flex justify-center">
              <div className="w-10 h-10 border-3 border-[#9BB7A3]/30 border-t-[#9BB7A3] rounded-full animate-spin"></div>
            </div>
          ) : dbServices.length === 0 ? (
            <div className="text-center py-12 text-slate-500">
              No active services found.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {dbServices.map((service) => {
                const asset = getServiceAsset(service);
                return (
                  <div
                    key={service.id}
                    onClick={() => setSelectedService(service)}
                    className="
                      group
                      cursor-pointer
                      relative
                      overflow-hidden
                      rounded-[28px]
                      bg-white/90
                      backdrop-blur-xl
                      border
                      border-white
                      shadow-lg
                      hover:shadow-2xl
                      hover:-translate-y-3
                      transition-all
                      duration-500
                    "
                  >
                    <div className="overflow-hidden h-72">
                      <img
                        src={asset.banner}
                        alt={service.name}
                        className="
                          h-full
                          w-full
                          object-cover
                          transition-all
                          duration-700
                          group-hover:scale-110
                        "
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-center">
                      <h3 className="text-2xl font-bold text-white">
                        {service.name}
                      </h3>
                      {service.description && (
                        <p className="text-xs text-slate-200/90 mt-2 line-clamp-2">
                          {service.description}
                        </p>
                      )}
                      <span className="inline-block mt-3 px-3 py-1 rounded-full bg-[#9BB7A3]/80 text-white text-[11px] font-bold uppercase tracking-wider backdrop-blur-sm">
                        Explore Collection
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* Dynamic Main Popup */}
      {currentPopup && (
        <div
          className="
            fixed
            inset-0
            z-40
            flex
            items-center
            justify-center
            bg-black/60
            backdrop-blur-md
            p-4
          "
          onClick={handleCloseMainPopup}
        >
          <div
            className="
              relative
              w-full
              max-w-5xl
              bg-white
              rounded-[32px]
              p-6
              md:p-8
              shadow-2xl
              animate-[popup_0.3s_ease]
            "
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseMainPopup}
              className="
                absolute
                top-5
                right-5
                w-10
                h-10
                rounded-full
                bg-slate-100
                hover:bg-red-100
                text-slate-700
                font-bold
                text-xl
                transition
                z-10
              "
            >
              ×
            </button>

            {selectedSubCategory && (
              <button
                onClick={() => setSelectedSubCategory(null)}
                className="
                  absolute
                  top-5
                  left-5
                  px-4
                  h-10
                  rounded-full
                  bg-slate-100
                  hover:bg-slate-200
                  text-slate-700
                  font-bold
                  text-sm
                  transition
                  z-10
                "
              >
                ← Back
              </button>
            )}

            <h2 className="text-2xl md:text-4xl font-black text-center text-slate-800 mb-2">
              {selectedSubCategory ? `${selectedSubCategory.title} Gallery` : currentPopup.title}
            </h2>
            {currentPopup.description && !selectedSubCategory && (
              <p className="text-center text-xs sm:text-sm text-slate-500 max-w-xl mx-auto mb-6">
                {currentPopup.description}
              </p>
            )}

            <div className="max-h-[70vh] overflow-y-auto p-2">
              {selectedSubCategory && selectedSubCategory.subImages ? (
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                  {selectedSubCategory.subImages.map((src, index) => (
                    <div
                      key={index}
                      onClick={() => openFullScreen(selectedSubCategory.subImages, index)}
                      className="
                        cursor-pointer
                        overflow-hidden
                        rounded-xl
                        border
                        border-slate-200
                        shadow-sm
                        hover:shadow-md
                        transition-all
                        duration-300
                      "
                    >
                      <img
                        src={src}
                        alt={`${selectedSubCategory.title} view ${index + 1}`}
                        className="h-28 md:h-36 w-full object-cover hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {currentPopup.items.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        if (item.subImages && item.subImages.length > 0) {
                          setSelectedSubCategory(item);
                        } else {
                          const allImages = currentPopup.items.map((i) => i.image);
                          openFullScreen(allImages, index);
                        }
                      }}
                      className="
                        group
                        cursor-pointer
                        overflow-hidden
                        rounded-2xl
                        bg-slate-50
                        border
                        border-slate-200
                        hover:shadow-xl
                        transition-all
                        duration-500
                        hover:-translate-y-2
                      "
                    >
                      <div className="overflow-hidden">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="
                            h-32
                            md:h-36
                            w-full
                            object-cover
                            transition-all
                            duration-700
                            group-hover:scale-110
                          "
                        />
                      </div>
                      <div className="p-3">
                        <h3 className="text-sm md:text-base font-bold text-center text-slate-700">
                          {item.title}
                        </h3>
                        <p className="text-[11px] text-[#9BB7A3] text-center font-semibold mt-0.5 group-hover:underline">
                          {item.subImages ? "Click to View Gallery" : "Click to View Full Screen"}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Full Screen Image Modal with Left/Right Navigation */}
      {currentImageIndex !== null && activeGallery.length > 0 && (
        <div
          className="
            fixed
            inset-0
            z-50
            flex
            items-center
            justify-center
            bg-black/90
            backdrop-blur-lg
            p-4
          "
          onClick={handleCloseFullScreen}
        >
          {/* Close Button */}
          <button
            onClick={handleCloseFullScreen}
            className="
              absolute
              top-6
              right-6
              w-12
              h-12
              rounded-full
              bg-white/20
              hover:bg-white/40
              text-white
              font-bold
              text-2xl
              flex
              items-center
              justify-center
              transition
              z-50
            "
          >
            ×
          </button>

          {/* Left Arrow */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              handlePrevImage();
            }}
            className="
              absolute
              left-4
              md:left-8
              top-1/2
              -translate-y-1/2
              w-12
              h-12
              rounded-full
              bg-white/20
              hover:bg-white/40
              text-white
              font-bold
              text-3xl
              flex
              items-center
              justify-center
              transition
              z-50
            "
          >
            ‹
          </button>

          {/* Main Fullscreen Image */}
          <div className="relative max-w-full max-h-[90vh] flex flex-col items-center">
            <img
              src={activeGallery[currentImageIndex]}
              alt={`Full view ${currentImageIndex + 1}`}
              className="
                max-w-full
                max-h-[85vh]
                object-contain
                rounded-lg
                shadow-2xl
                animate-[popup_0.2s_ease]
              "
              onClick={(e) => e.stopPropagation()}
            />
            <div className="mt-2 text-white/80 font-medium text-sm">
              {currentImageIndex + 1} / {activeGallery.length}
            </div>
          </div>

          {/* Right Arrow */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleNextImage();
            }}
            className="
              absolute
              right-4
              md:right-8
              top-1/2
              -translate-y-1/2
              w-12
              h-12
              rounded-full
              bg-white/20
              hover:bg-white/40
              text-white
              font-bold
              text-3xl
              flex
              items-center
              justify-center
              transition
              z-50
            "
          >
            ›
          </button>
        </div>
      )}

      <style>
        {`
          @keyframes popup {
            from {
              opacity: 0;
              transform: scale(0.85);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>
    </>
  );
}

export default Services;